import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormPopup from '../common/popup/form-popup';
import InputSubmit from '../common/form/input-submit';
import DynamicSearch from '../partials/common/dynamic-search';
import { getPathParam } from '../../utils/converter';
import { COMPANY } from '../../api/endpoints';
import { useSelector } from 'react-redux';
import { BOARD, BOARDS, STATUSES } from '../../routes/endpoints';
import UsersToolbar from '../common/card/users-toolbar';
import UserInitial from '../common/table/user-initial';
import { getCustomFormat, getFormattedDate } from '../../utils/timeUtils';
import TooltipItem from '../common/button/tooltip';
import { ChatIcon, ClipboardIcon, ClockIcon, DocumentTextIcon, MenuAlt1Icon, PaperClipIcon } from '@heroicons/react/outline';
import CalendarIcon from '../../resources/icons/CalendarIcon';
import { getFileType } from '../../constants/file-extension';
import TaskManage from '../../routes/board/task-manage';
import CustomUserSelect from '../common/form/custom-user-select';
import moment from 'moment';
import NumberFormat from 'react-number-format';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function addNewLine(stringa, len) {
  let risultato = '';
  let parole = stringa.split(' ');
  let rigaCorrente = '';

  for (let i = 0; i < parole.length; i++) {
    if (rigaCorrente.length + parole[i].length + 1 > len) {
      risultato += rigaCorrente.trim() + '\n';
      rigaCorrente = '';
    }
    rigaCorrente += parole[i] + ' ';
  }

  risultato += rigaCorrente.trim();

  return risultato;
}

function CompanyBoard({ height, data, isEditing, setIsOpen, dashboardWidget, onFinalSubmit, onRefreshed }) {


  const [isOpenTask, setOpenTask] = useState(false);
  const [statusTaskDetail, setStatusTaskDetail] = useState(false);
  const [boardData, setBoardData] = useState(false);
  const [taskDetail, setTaskDetail] = useState(false);


  return (
    <div style={{ height: height + 'px' }} className='overflow-x-hidden overflow-y-scroll'>

      {
        (data?.tasks ?? []).map((task) => (
          <QuoteItem key={task.id} task={task} onOpen={() => {
            setStatusTaskDetail(task.board_status);
            setBoardData(task.virtual_board);
            setTaskDetail(task);
            setOpenTask(true);
          }} />
        ))
      }

      {
        (statusTaskDetail && boardData && taskDetail) && (
          <TaskManage
            isOpen={isOpenTask}
            setIsOpen={setOpenTask}
            boardData={boardData}
            statusDetail={statusTaskDetail}
            taskDetail={taskDetail}
            onRefresh={(r) => {
              onRefreshed();
            }}
            setClean={() => {
              setStatusTaskDetail(false);
              setBoardData(false);
              setTaskDetail(false);
              setOpenTask(false);
            }}
            onOpenReletadTask={(taskData) => {
              setStatusTaskDetail(taskData.board_status);
              setBoardData(taskData.virtual_board);
              setTaskDetail(taskData);
              setOpenTask(true);
            }}
          />
        )
      }
       
      <BoardEdit
        isEditing={isEditing}
        setIsOpen={setIsOpen}
        dashboardWidget={dashboardWidget}
        onFinalSubmit={(r) => {
          onFinalSubmit(r);
        }}
      />
    </div>
  );
}


const QuoteItem = ({ task, onOpen }) => {
  const [pictureAttachment, setPictureAttachment] = useState(false);
  const { t } = useTranslation();
  const { company } = useSelector((state) => state.userCompany);
  const now = moment();

  const findPirctureAttachment = (attachments) => {

    let flag = true;
    let isStop = false;
    // eslint-disable-next-line
    attachments.map((attachment) => {
      if (attachment.file && !isStop) {
        const ext = attachment.file.reference.split('.').pop();
        const fileType = getFileType(ext);
        if (fileType && fileType.split('/').shift() === 'image') {
          setPictureAttachment(attachment.file.reference);
          flag = false;
          isStop = true;
        }
      }
    });

    if (flag) {
      setPictureAttachment(false);
    }
  }

  useEffect(() => {
    if (task) {
      findPirctureAttachment(task?.task_attachments ?? []);
    }
  }, [task])


  const getCheckListCount = (checklists) => {
    let total = 0;
    let confirmed = 0;
    // eslint-disable-next-line
    (checklists ?? []).map((checklist) => {
      // eslint-disable-next-line
      (checklist?.checklists ?? []).map((item) => {
        // eslint-disable-next-line
        if (item.status) {
          confirmed = confirmed + 1;
        }
        total = total + 1;
      })
    })
    return confirmed + "/" + total;
  }

  const getCheckPercentage = (checklists) => {
    let percentage = 0;
    let confirmed = 0;
    let total = 0;
    // eslint-disable-next-line
    (checklists ?? []).map((checklist) => {
      // eslint-disable-next-line
      (checklist?.checklists ?? []).map((item) => {
        // eslint-disable-next-line
        if (item.status) {
          confirmed = confirmed + 1;
        }
        total = total + 1;
      })
    })

    if (total > 0) {
      percentage = (100 / total) * confirmed;
    }

    return percentage;
  }


  const taskMembers = (task) => {
    let users = [];
    if (!task) {
      return users;
    }
    const assignedUsers = task.assigned_users ?? [];
    if (assignedUsers.length > 0) {
      users = task.user?.id ? assignedUsers.filter(r => r.id !== task.user.id) : assignedUsers;
    }
    if (task.user) {
      users.splice(0, 0, task.user);
    }
    return users;
  }

  const boardTitle = task?.virtual_board?.title;
  const statusTitle = task?.board_status?.title;
  const dueMoment = task?.end_date ? moment(task.end_date, "YYYY-M-D HH:mm:ss") : null;
  const isOverdue = dueMoment ? dueMoment.isBefore(now) : false;
  const isDueSoon = dueMoment ? dueMoment.diff(now, 'days') <= 2 && dueMoment.diff(now, 'days') >= 0 : false;
  const hasChecklist = (task?.check_list ?? []).length > 0;
  const attachedProperties = (task?.properties ?? []).filter(r => (r?.attach ?? false) === true);
  const members = taskMembers(task);
  const visibleMembers = members.length > 4 ? members.slice(0, 4) : members;
  const overflowCount = members.length - visibleMembers.length;

  const getDueBadgeClasses = () => {
    if (!task.task_date && !task.end_date) {
      return "bg-gray-100 text-gray-600 ring-1 ring-gray-100";
    }
    if (isOverdue) {
      return "bg-red-50 text-red-600 ring-1 ring-red-100";
    }
    if (isDueSoon) {
      return "bg-amber-50 text-amber-600 ring-1 ring-amber-100";
    }
    return "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100";
  };

  const renderPropertyValue = (property) => {
    if (property.type === 'date') {
      return (
        <b>{getFormattedDate(property.value)}</b>
      )
    }

    if (property.type === 'text') {
      return (
        <b>{property.value}</b>
      )
    }

    if (property.type === 'number') {
      return (
        <b>
          <NumberFormat
            value={property.value}
            displayType={"text"}
            decimalScale={2}
            thousandSeparator={"."}
            decimalSeparator={","}
            prefix={""}
          />
        </b>
      )
    }

    if (property.type === 'currency') {
      return (
        <b>
          <NumberFormat
            value={property.value}
            displayType={"text"}
            decimalScale={2}
            thousandSeparator={"."}
            decimalSeparator={","}
            suffix={" " + (company.currency?.currency_symbol ?? '')}
          />
        </b>
      )
    }

    return null;
  }

  const getFormattedPeriod = () => {
    if (!task.task_date && !task.end_date) {
      return '';
    }
    const start = task.task_date ? getCustomFormat(task.task_date, "DD/MM/YYYY") : null;
    const end = task.end_date ? getCustomFormat(task.end_date, "DD/MM/YYYY") : null;
    if (start && end) {
      return `${start} - ${end}`;
    }
    return start ?? end ?? '';
  }


  return (
    <div
      className="group  flex flex-col  border border-gray-200 bg-white shadow-sm transition-all duration-150 hover:-translate-y-0.5 hover:border-indigo-200 hover:shadow-md"
      onClick={() => {
        onOpen(true)
      }}
    >

      {
        task && (
          <>
            {
              pictureAttachment && (
                <div className='overflow-hidden  bg-gray-900 '>
                  <img className="h-[220px] w-full object-cover transition duration-300 ease-out group-hover:scale-105" src={pictureAttachment} alt="" />
                </div>
              )
            }
            <div className={classNames(pictureAttachment ? 'p-4' : 'p-5', 'space-y-4')}>
              <div className='flex flex-wrap items-start justify-between gap-2'>
                <div className='space-y-1'>
                  {boardTitle && (
                    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                      {boardTitle}
                    </p>
                  )}
                  <p className="text-xs font-medium uppercase tracking-wide text-gray-500">
                    {task.task_reference}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  {statusTitle && (
                    <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-1 text-[11px] font-semibold text-gray-700">
                      {statusTitle}
                    </span>
                  )}
                  {
                    hasChecklist && (
                      <div className="flex items-center gap-2 text-xs text-gray-600 cursor-default">
                        <TooltipItem position={"left"} tooltipsText={t("app.board.tol_checklist")}>
                          <div className='flex items-center gap-2'>
                            <div className="h-1.5 w-16 rounded-full bg-gray-200">
                              <div
                                className={classNames(
                                  getCheckPercentage(task.check_list) >= 50 ? 'bg-emerald-500' : 'bg-amber-500',
                                  "h-1.5 rounded-full transition-all"
                                )}
                                style={{ width: getCheckPercentage(task.check_list) + '%' }}
                              />
                            </div>
                            <div className='flex items-center text-[11px] font-semibold'>
                              {getCheckListCount(task.check_list)}
                              <ClipboardIcon className="ml-1 h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
                            </div>
                          </div>
                        </TooltipItem>
                      </div>
                    )
                  }
                </div>
              </div>

              <div className='space-y-2'>
                <h1 className="text-lg font-semibold leading-6 text-gray-900 whitespace-pre-line">
                  {addNewLine(task.title, 45)}
                </h1>

                {
                  (task.task_date || task.end_date) && (
                    <div className="flex flex-wrap items-center gap-2 text-xs">
                      <span className={classNames(
                        "inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-medium ring-1",
                        getDueBadgeClasses()
                      )}>
                        {isOverdue ? (
                          <ClockIcon className="h-3.5 w-3.5" />
                        ) : (
                          <CalendarIcon className="h-3.5 w-3.5  flex-shrink-0" aria-hidden="true" />
                        )}
                        {getFormattedPeriod()}
                      </span>
                      {isOverdue && (
                        <span className="text-[11px] font-semibold uppercase tracking-wide text-red-500">
                          {t("app.board.overdue_label", { defaultValue: "Overdue" })}
                        </span>
                      )}
                    </div>
                  )
                }
              </div>



              {
                attachedProperties.length > 0 && (
                  <div className="flex flex-wrap gap-2">
                    {
                      attachedProperties.map((property) => (
                        <div
                          key={`${property.id ?? property.title}`}
                          className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-3 py-1 text-[11px] font-medium text-gray-700"
                        >
                          <span>{property.title}:</span> {renderPropertyValue(property)}
                        </div>
                      ))
                    }
                  </div>
                )
              }





              {
                (task.description || task.related_tasks_count > 0 || task.attachment_count > 0 || task.activities_count > 0) ? (
                  <div className=" flex flex-row flex-wrap items-center gap-3 text-xs text-gray-500">

                    {
                      task.description && (
                        <div className="flex items-center cursor-default">
                          <TooltipItem position={"right"} tooltipsText={t("app.board.tol_description")}>
                            <MenuAlt1Icon className="h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
                          </TooltipItem>
                        </div>
                      )
                    }
                    {
                      task.related_tasks_count > 0 && (
                        <div className="flex items-center gap-1 cursor-default">
                          <TooltipItem position={"right"} tooltipsText={t("app.board.tol_sub_task")}>
                            <DocumentTextIcon className="h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
                            <span>{task.related_tasks_count}</span>
                          </TooltipItem>
                        </div>
                      )
                    }

                    {
                      task.attachment_count > 0 && (
                        <div className="flex items-center gap-1 cursor-default">
                          <TooltipItem position={"right"} tooltipsText={t("app.board.tol_attachment")}>
                            <PaperClipIcon className="h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
                            <span>{task.attachment_count}</span>
                          </TooltipItem>
                        </div>
                      )
                    }

                    {
                      task.activities_count > 0 && (
                        <div className="flex items-center gap-1 cursor-default">
                          <TooltipItem position={"right"} tooltipsText={t("app.board.tol_comment")}>
                            <ChatIcon className="h-4 w-4 flex-shrink-0 text-gray-500" aria-hidden="true" />
                            <span>{task.activities_count}</span>
                          </TooltipItem>
                        </div>
                      )
                    }

                  </div>
                ) : (
                    <div className='mb-4' />

                )}


              <div className='flex flex-wrap items-end justify-between gap-4'>

                <div>
                  {
                    task.created === task.updated ? (
                      <p className="mt-0.5 text-[11px] text-gray-500">
                        {t("app.board.created_on", { date: getCustomFormat(task.created, "DD/MM/YYYY") })}
                      </p>
                    ) : (
                      <p className="mt-0.5 text-[11px] text-gray-500">
                        {t("app.board.updated_on", { date: getCustomFormat(task.updated, "DD/MM/YYYY") })}
                      </p>
                    )
                  }
                </div>

                {
                  members.length > 0 && (
                    <UsersToolbar users={members} isActive={members.length > 0} extraData={getCustomFormat(task.created, "DD/MM/YYYY")} className={'flex-shrink-0'}>
                      <div className="flex items-center space-x-2">
                        <div className={visibleMembers.length === 1 ? "flex items-center gap-1 text-sm" : "flex flex-shrink-0 -space-x-1"}>

                          {visibleMembers.map((user, index) => (
                            index === 0 ? (
                              <UserInitial user={user} ringClass={" ring-yellow-400 "} />
                            ) : (
                              <UserInitial user={user} />
                            )
                          ))}
                        </div>

                        {overflowCount > 0 ? (
                          <span className="flex-shrink-0 text-xs font-medium leading-5 text-gray-600">
                            +{overflowCount}
                          </span>
                        ) : null}
                      </div>
                    </UsersToolbar>
                  )
                }

              </div>



            </div>


          </>
        )
      }



    </div>
  );
}

function BoardEdit({ isEditing, setIsOpen, dashboardWidget, onFinalSubmit }) {
  const { t } = useTranslation();
  const { loggedCompany } = useSelector((state) => state.user);
  const [selectedUsers, setSelectedUsers] = useState();

  const {
    handleSubmit,
    control,
    setValue,
    watch
  } = useForm();

  const onSubmit = (data) => {
   const output = {
      id: dashboardWidget.id,
      configuration: {
        board_id: data.dynamic_board.id,
        status_id: data.dynamic_status.id,
        users: data.users
      }
    };
    onFinalSubmit(output)
  };


  useEffect(() => {

    if (watch('dynamic_board') && watch('dynamic_board').assigned_users.length > 0 && dashboardWidget.users && dashboardWidget.users.length > 0){
      let data = [];

      // eslint-disable-next-line
      dashboardWidget.users.map(d => {
        data.push(watch('dynamic_board').assigned_users.find(n=> n.id === d));
      })
      setSelectedUsers(data);
    }

    // eslint-disable-next-line
  }, [dashboardWidget, watch('dynamic_board') , setValue]);

  

  return (
    <FormPopup
      title={dashboardWidget.dashboard_widget.name}
      isOpen={isEditing}
      setIsOpen={(r) => {
        setIsOpen(r);
      }}
    >

      <form onSubmit={handleSubmit(onSubmit)}>

        <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-y-4 gap-x-4 sm:grid-cols-1">
          <div className="col-span-2 md:col-span-1 ">
            <Controller
              name="dynamic_board"
              rules={{ required: false }}
              control={control}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <DynamicSearch
                  selectLabel={t("app.board.title")}
                  endpoint={getPathParam([COMPANY, loggedCompany.id, BOARDS])}
                  responseLabel={'boards'}
                  label={'title'}
                  errors={error}
                  value={value}
                  name={name}
                  onResponse={(r) => {
                    let item = r.find(item => item.id === dashboardWidget?.configuration?.board_id ?? '');
                    if (item) {
                      setValue('dynamic_board', item);
                    }
                  }}
                  onChange={async (r) => {
                    onChange(r);
                  }}
                />
              )}
            />
          </div>


          <div className="col-span-2 md:col-span-1 ">
            <Controller
              name="dynamic_status"
              rules={{ required: false }}
              control={control}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <DynamicSearch
                  selectLabel={t("app.board.status_select")}
                  endpoint={getPathParam([BOARD, watch('dynamic_board')?.id ?? '', STATUSES])}
                  responseLabel={'statuses'}
                  label={'title'}
                  errors={error}
                  value={value}
                  isDisabled={!watch('dynamic_board')}
                  name={name}
                  onResponse={(r) => {
                    let item = r.find(item => item.id === dashboardWidget?.configuration?.status_id ?? '');
                    if (item) {
                      setValue('dynamic_status', item);
                    }
                  }}
                  onChange={async (r) => {
                    onChange(r);
                  }}
                />
              )}
            />
          </div>


          <div className="col-span-2 md:col-span-2 ">
            <CustomUserSelect
              label={t('app.board.board_user')}
              users={watch('dynamic_board')?.assigned_users ?? []}
              isShowLabel={false}
              placeholder={''}
              multiple={true}
              includeAll={true}
              excludeId={''}
              selectedUsers={selectedUsers}
              onSelect={(r) => {
                setSelectedUsers(r);

             
                let data = [];
                if (r.length > 0) {
                  // eslint-disable-next-line
                  r.map((user) => {
                    data.push(user.id)
                  })
                }

                setValue('users', data);
               
              }}
            />
          </div>



          


        </div>

        <div className="flex before:flex-1 items-center justify-between mt-6">
          <InputSubmit
            isLoading={false}
            label={t("app.form.save")}
          />
        </div>

      </form>

    </FormPopup>
  );
}



export default CompanyBoard;
